import {axiosUtil} from "../../../utils/axios_util";

const userGroupApi = {
    //用户组分页查询
    getUserGroupPage(data:powerSearchData) {
        return axiosUtil({
            url: '/user_group/page',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
    //删除用户组
    deleteUserGroup(data: string) {
        return axiosUtil({
            url: `/user_group/delete/${data}`,
            method: 'get',
            data
        })
    },
    //编辑用户组
    editUserGroup(data:any) {
        return axiosUtil({
            url: `/user_group/edit/${data.groupNo}`,
            method: 'post',
            data,
        })
    },
    //保存用户组
    saveUserGroup(data:any) {
        return axiosUtil({
            url: `/user_group/save`,
            method: 'post',
            data,
        })
    },
    //获取用户组账户列表
    getUserGroupList(data: string) {
        return axiosUtil({
            url: `/user_account/get_group_account_list/${data}`,
            method: 'get',
            data
        })
    },

    //是否启用用户账户
    setEnable(data:any) {
        return axiosUtil({
            url: `/user_group/enable/${data.accountNo}`,
            method: 'get',
            data,
            params: {
                enable: data.isEnable
            }
        })
    },
}

export default userGroupApi
